import { buildFormDataFromJson, xhrFetch } from "../xhrManager";
import Message from "../Helpers/UI/Message";
import { getMessage } from "../Helpers/Datas/messages";
import Wishlist from "./Models/Wishlist";
import ApiHelper from "../Helpers/API/ApiHelper";

export default class WishlistAPI {
    constructor() {
        this.apiHelper = new ApiHelper();
    }

    async getWishlists(successCallback, errorCallback, xApiToken = null) {
        return await xhrFetch(
            `${this.apiHelper.apiUrl}/wishlists`,
            {
                method: "GET",
                headers: this.apiHelper.getHeaders(xApiToken),
            },
            (response) => {
                const wishlists = response.wishlists.map((wishlist) => {
                    return new Wishlist(wishlist);
                });
                successCallback(wishlists);
            },
            (exception) => {
                errorCallback(exception);
                Message.displayMessage(getMessage("wishlist.requestFailed"), "wishlist", "error");
            }
        );
    }

    async getWishlist(wishlistId, successCallback, errorCallback, xApiToken = null) {
        return await xhrFetch(
            `${this.apiHelper.apiUrl}/wishlists/${wishlistId}`,
            {
                method: "GET",
                headers: this.apiHelper.getHeaders(xApiToken),
            },
            (response) => {
                const wishlist = new Wishlist(response);
                successCallback(wishlist);
            },
            (exception) => {
                errorCallback(exception);
                Message.displayMessage(getMessage("wishlist.requestFailed"), "wishlist", "error");
            }
        );
    }

    async createWishlist(json, successCallback, errorCallback) {
        await xhrFetch(
            `${this.apiHelper.apiUrl}/wishlists`,
            {
                method: "POST",
                headers: this.apiHelper.getHeaders(),
                body: buildFormDataFromJson(json),
            },
            (response) => {
                const wishlist = new Wishlist(response);
                successCallback(wishlist);
                Message.displayMessage(getMessage("wishlist.wishlistCreated"), "wishlist", "success");
            },
            (exception) => {
                errorCallback(exception);
                Message.displayMessage(getMessage("wishlist.requestFailed"), "wishlist", "error");
            }
        );
    }

    async updateWishlist(wishlistId, json, successCallback, errorCallback, noMessage = false) {
        await xhrFetch(
            `${this.apiHelper.apiUrl}/wishlists/${wishlistId}`,
            {
                method: "PUT",
                headers: this.apiHelper.getHeaders(),
                body: buildFormDataFromJson(json),
            },
            (response) => {
                const wishlist = new Wishlist(response);
                successCallback(wishlist);
                if (!noMessage) {
                    Message.displayMessage(getMessage("wishlist.wishlistEdited"), "wishlist", "success");
                }
            },
            (exception) => {
                errorCallback(exception);
                if (!noMessage) {
                    Message.displayMessage(getMessage("wishlist.requestFailed"), "wishlist", "error");
                }
            }
        );
    }

    async removeWishlist(wishlistId, successCallback) {
        await xhrFetch(
            `${this.apiHelper.apiUrl}/wishlists/${wishlistId}`,
            {
                method: "DELETE",
                headers: this.apiHelper.getHeaders(),
            },
            (response) => {
                successCallback(response);
                Message.displayMessage(getMessage("wishlist.wishlistRemoved"), "wishlist", "success");
            },
            (exception) => {
                Message.displayMessage(getMessage("wishlist.requestFailed"), "wishlist", "error");
            }
        );
    }

    async addVariantToWishlist(wishlistId, json, successCallback, errorCallback) {
        await xhrFetch(
            `${this.apiHelper.apiUrl}/wishlists/${wishlistId}/variants`,
            {
                method: "POST",
                headers: this.apiHelper.getHeaders(),
                body: buildFormDataFromJson(json),
            },
            (response) => {
                successCallback(response);
                Message.displayMessage(getMessage("wishlist.productAdded"), "wishlist", "success");
            },
            (exception) => {
                errorCallback(exception);
                if (exception.status === 422) {
                    Message.displayMessage(getMessage("wishlist.productExists"), "wishlist", "error");
                } else {
                    Message.displayMessage(getMessage("wishlist.requestFailed"), "wishlist", "error");
                }
            }
        );
    }

    async removeVariant(wishlistId, variantId, successCallback, errorCallback) {
        await xhrFetch(
            `${this.apiHelper.apiUrl}/wishlists/${wishlistId}/variants/${variantId}`,
            {
                method: "DELETE",
                headers: this.apiHelper.getHeaders(),
            },
            (response) => {
                successCallback(response);
                Message.displayMessage(getMessage("wishlist.productRemoved"), "wishlist", "success");
            },
            (exception) => {
                errorCallback(exception);
                Message.displayMessage(getMessage("wishlist.requestFailed"), "wishlist", "error");
            }
        );
    }

    async updateProductVariantInWishlist(wishlistId, variantId, json, successCallback, errorCallback) {
        await xhrFetch(
            `${this.apiHelper.apiUrl}/wishlists/${wishlistId}/variants/${variantId}`,
            {
                method: "PUT",
                headers: this.apiHelper.getHeaders(),
                body: buildFormDataFromJson(json),
            },
            (response) => {
                successCallback(response);
                Message.displayMessage(getMessage("wishlist.wishlistEdited"), "wishlist", "success");
            },
            (exception) => {
                errorCallback(exception);
                Message.displayMessage(getMessage("wishlist.requestFailed"), "wishlist", "error");
            }
        );
    }

    async migrateWishlists(json, successCallback, errorCallback) {
        await xhrFetch(
            `${this.apiHelper.apiUrl}/wishlists/migrate`,
            {
                method: "POST",
                headers: this.apiHelper.getHeaders(this.apiHelper.getApiAnonToken("wishlist_anon_token")),
                body: buildFormDataFromJson(json),
            },
            (response) => {
                successCallback(response);
                Message.displayMessage(getMessage("wishlist.wishlistMigrated"), "wishlist", "success");
            },
            (exception) => {
                errorCallback(exception);
                Message.displayMessage(getMessage("wishlist.requestFailed"), "wishlist", "error");
            }
        );
    }
}
